import React from 'react';
import Layout from '../components/Layout/Layout';
import "../styles/AboutUs.css";

const About = () => {
  return (
    <Layout title={"من نحن - النخبة ستور"}>
      {/* Hero */}
      <div className="about-hero">
        <img src="/images/logo2.jpeg" alt="النخبة ستور" className="about-hero-bg" />
        <div className="about-hero-overlay">
          <h1>من نحن</h1>
          <p>قصة النخبة ستور</p>
        </div>
      </div>

      <div className="about-us-page">
        {/* Logo + Intro */}
        <div className="about-intro">
          <div className="about-logo-section">
            <img src="/images/logo1.jpeg" alt="النخبة ستور" className="about-logo" />
          </div>
          <div className="about-intro-text">
            <h2 className="section-title">النخبة ستور</h2>
            <p className="section-text">
              نحن النخبة ستور، متجر إلكتروني رائد في العراق متخصص في توفير أحدث الهواتف الذكية والأجهزة الإلكترونية. فريقنا شغوف بالتكنولوجيا ويسعى لتقديم مجموعة واسعة من المنتجات التي تلبي جميع الاحتياجات والميزانيات.
            </p>
          </div>
        </div>

        {/* Values Grid */}
        <div className="values-grid">
          <div className="value-card">
            <div className="value-icon">🎯</div>
            <h3>مهمتنا</h3>
            <p>جعل تجربة التسوق الإلكتروني استثنائية. نؤمن بأن كل عميل فريد من نوعه، ونحن ملتزمون بتقديم خدمة شخصية تلبي احتياجاتك. سواء كنت تبحث عن أحدث هاتف ذكي أو خيار اقتصادي، نحن هنا لمساعدتك.</p>
          </div>
          <div className="value-card">
            <div className="value-icon">💎</div>
            <h3>قيمنا</h3>
            <p>نحن مدفوعون بالتزامنا بتقديم خدمة استثنائية ومنتجات عالية الجودة. نؤمن بالصدق والنزاهة والشفافية في جميع تعاملاتنا. هدفنا هو بناء علاقات طويلة الأمد مع عملائنا.</p>
          </div>
          <div className="value-card">
            <div className="value-icon">🛡️</div>
            <h3>ضماننا</h3>
            <p>جميع منتجاتنا أصلية 100% مع ضمان رسمي. نوفر خدمة ما بعد البيع المتميزة وإمكانية الاستبدال خلال 7 أيام من الشراء لضمان رضاكم التام.</p>
          </div>
        </div>

        {/* Stats */}
        <div className="about-stats">
          <div className="stat-item">
            <span className="stat-number">1000+</span>
            <span className="stat-label">عميل سعيد</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">500+</span>
            <span className="stat-label">منتج متوفر</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">18</span>
            <span className="stat-label">محافظة عراقية</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">24/7</span>
            <span className="stat-label">خدمة العملاء</span>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default About
